import React from 'react';
import { Select, SelectItem } from '@heroui/react';
import { Globe } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import { FiltersBar, FilterField } from '../base';
import { useLanguage } from '../../contexts/LanguageContext';

interface CoursesFiltersBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedLanguage?: string;
  onLanguageChange: (language: string) => void;
  onClearFilters: () => void;
  hasActiveFilters: boolean;
}

const CoursesFiltersBar: React.FC<CoursesFiltersBarProps> = ({
  searchQuery,
  onSearchChange,
  selectedLanguage,
  onLanguageChange,
  onClearFilters,
  hasActiveFilters,
}) => {
  const { t } = useTranslation('courses');
  const { availableLanguages } = useLanguage();

  return (
    <FiltersBar
      title={t('filters.title')}
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      searchPlaceholder={t('filters.searchPlaceholder')}
      hasActiveFilters={hasActiveFilters}
      onClearFilters={onClearFilters}
      clearFiltersLabel={t('filters.clearAll')}
      gridCols="2"
    >
      <FilterField label={t('filters.language')} icon={Globe}>
        <Select
          placeholder={t('filters.selectLanguage')}
          selectedKeys={selectedLanguage ? [selectedLanguage] : []}
          onSelectionChange={(keys) => {
            const selected = Array.from(keys)[0] as string;
            onLanguageChange(selected || 'en');
          }}
          variant="bordered"
          label=""
          className="w-full"
          selectionMode="single"
          classNames={{
            trigger:
              'border-gray-300 dark:border-gray-700 hover:border-indigo-400 dark:hover:border-indigo-600 transition-colors',
          }}
        >
          <>
            <SelectItem key="all">{t('filters.allLanguages')}</SelectItem>
            {availableLanguages.map((lang) => (
              <SelectItem key={lang.code}>{lang.name}</SelectItem>
            ))}
          </>
        </Select>
      </FilterField>
    </FiltersBar>
  );
};

export default CoursesFiltersBar;
